export const filterPendingByRegisterScope = (
  purchases,
  { cashRegisterSessionId } = {}
) => {
  const list = Array.isArray(purchases) ? purchases : [];
  const hasSession =
    cashRegisterSessionId !== null
    && cashRegisterSessionId !== undefined
    && cashRegisterSessionId !== '';
  if (hasSession) {
    const sessionKey = String(cashRegisterSessionId);
    return list.filter(
      (purchase) => String(purchase?.cashRegisterSessionId ?? '') === sessionKey
    );
  }
  return [];
};
